export interface IFileUpload {
    width: string;
    height: string;
    ocorrenciaNo: number;
	atividadeNo: number;
}
